import {
    AchChildSupportRecipientAddendaBaseDto,
    AchChildSupportRecipientResponseDto,
    ChildSupportAddendaDto,
    ChildSupportRecipientDto,
} from '@treasury/api/channel';
import { DomainEntity } from '../shared';

export interface ChildSupportAddenda {
    id?: string;
    recipientId?: string;
    caseIdentifier?: string;
    employmentTermination: boolean;
    fipsCode?: string;
    medicalSupport: boolean;
    nonCustodialParentFirstName?: string;
    nonCustodialParentLastName?: string;
    nonCustodialParentSsn?: string;
    payDate?: string;
}

export class ChildSupportRecipient extends DomainEntity<ChildSupportRecipientDto> {
    public createDefault(): this {
        return new ChildSupportRecipient({
            id: 0,
            updatedDate: '',
            name: '',
            idNumber: '',
            accountNumber: '',
            accountType: '',
            routingNumber: '',
            transactionType: 'CR',
            amount: 0,
            prenote: false,
            hold: false,
            reversal: false,
            addenda: [],
        } as unknown as ChildSupportRecipientDto) as this;
    }

    public get id() {
        return this.dto.id;
    }

    public get name() {
        return this.dto.name;
    }

    public get idNumber() {
        return this.dto.idNumber;
    }

    public get accountNumber() {
        return this.dto.accountNumber;
    }

    public get accountType() {
        return this.dto.accountType;
    }

    public get routingNumber() {
        return this.dto.routingNumber;
    }

    public get transactionType() {
        return this.dto.transactionType;
    }

    public get amount() {
        return this.dto.amount;
    }

    public get prenote() {
        return this.dto.prenote;
    }

    public get hold() {
        return this.dto.hold;
    }

    public get addenda(): ChildSupportAddendaDto[] {
        return this.dto.addenda ?? [];
    }

    public get primaryAddenda(): ChildSupportAddendaDto | undefined {
        return this.addenda[0];
    }

    public get nonCustodialParentSsn() {
        return this.primaryAddenda?.nonCustodialParentSsn ?? '';
    }

    public get nonCustodialParentFirstName() {
        return this.primaryAddenda?.nonCustodialParentFirstName ?? '';
    }

    public get nonCustodialParentLastName() {
        return this.primaryAddenda?.nonCustodialParentLastName ?? '';
    }

    public get caseIdentifier() {
        return this.primaryAddenda?.caseIdentifier ?? '';
    }

    public get fipsCode() {
        return this.primaryAddenda?.fipsCode ?? '';
    }

    public get payDate() {
        return this.primaryAddenda?.payDate ?? '';
    }

    public get employmentTermination() {
        return this.primaryAddenda?.employmentTermination ?? false;
    }

    public get medicalSupport() {
        return this.primaryAddenda?.medicalSupport ?? false;
    }

    public get formattedAmount() {
        return this.dto.amount.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
        });
    }
}

export class ChildSupportTemplateRecipient extends DomainEntity<AchChildSupportRecipientResponseDto> {
    public createDefault(): this {
        return new ChildSupportTemplateRecipient({
            id: '',
            name: '',
            idNumber: '',
            accountNumber: '',
            accountTypeName: '',
            routingNumber: '',
            transactionType: 2,
            transactionTypeDescription: '',
            amount: 0,
            isPrenote: false,
            holdTransaction: false,
            accountType: 0,
        } as unknown as AchChildSupportRecipientResponseDto) as this;
    }

    public get id() {
        return this.dto.id;
    }

    public get name() {
        return this.dto.name;
    }

    public get idNumber() {
        return this.dto.idNumber;
    }

    public get accountNumber() {
        return this.dto.accountNumber;
    }

    public get routingNumber() {
        return this.dto.routingNumber;
    }

    public get amount() {
        return this.dto.amount;
    }

    public get isPrenote() {
        return this.dto.isPrenote;
    }

    public get holdTransaction() {
        return this.dto.holdTransaction;
    }

    public get addenda(): AchChildSupportRecipientAddendaBaseDto | undefined {
        return this.dto.addenda;
    }

    public get nonCustodialParentSsn() {
        return this.addenda?.nonCustodialParentSsn ?? '';
    }

    public get nonCustodialParentFirstName() {
        return this.addenda?.nonCustodialParentFirstName ?? '';
    }

    public get nonCustodialParentLastName() {
        return this.addenda?.nonCustodialParentLastName ?? '';
    }

    public get caseIdentifier() {
        return this.addenda?.caseIdentifier ?? '';
    }

    public get fipsCode() {
        return this.addenda?.fipsCode ?? '';
    }

    public get employmentTermination() {
        return this.addenda?.employmentTermination ?? false;
    }

    public get medicalSupport() {
        return this.addenda?.medicalSupport ?? false;
    }

    public get formattedAmount() {
        return this.dto.amount.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
        });
    }
}
